import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Home, SearchX } from 'lucide-react';
import SEO from '@/components/SEO';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    // `data-page="not-found"` is how an automated check recognises this
    // screen. It must stay machine-readable: the heading is translated into
    // four languages, so matching its words would work in one of them
    // (INV-I18N-5). `scripts/smoke.js` fails any route that renders it —
    // three diaspora landings served this page to every visitor for months
    // while the pre-rendered HTML a crawler reads looked perfect.
    <div
      data-page="not-found"
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4"
    >
      <SEO title={t('notFoundPage.title')} description={t('notFoundPage.description')} path="/404" noIndex />
      <SearchX className="h-20 w-20 text-gray-300 mb-6" />
      <h1 className="text-3xl font-bold text-wefaqna-navy mb-3">
        {t('notFoundPage.title')}
      </h1>
      <p className="text-gray-500 mb-8 max-w-md">
        {t('notFoundPage.bodyApology')}
      </p>
      <Button
        onClick={() => navigate('/')}
        className="bg-wefaqna-forest text-white hover:bg-wefaqna-forest-hover gap-2"
      >
        <Home className="h-4 w-4" />
        {t('notFoundPage.backHome')}
      </Button>
    </div>
  );
}
